<platform-one-time-link-form
    [entity]="entity"
    (entityUpdate)="saveOneTimeLink($event)"></platform-one-time-link-form>
